import { Theme, alpha } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  const headerBackground = alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.18 : 0.06);

  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: headerBackground,
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          [`&.${tableRowClasses.selected}`]: {
            backgroundColor: alpha(theme.palette.primary.dark, 0.04),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.dark, 0.08),
            },
          },
          '&:last-of-type': {
            [`& .${tableCellClasses.root}`]: {
              borderColor: 'transparent',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontSize: 13,
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightSemiBold,
          letterSpacing: 0.2,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: headerBackground,
          '& .MuiTableSortLabel-root': {
            color: 'inherit',
            fontWeight: 'inherit',
          },
          '& .MuiTableSortLabel-root.Mui-active': {
            color: theme.palette.text.primary,
          },
          '& .MuiTableSortLabel-icon': {
            color: `${theme.palette.text.secondary} !important`,
          },
        },
        stickyHeader: {
          backgroundColor: headerBackground,
          backgroundImage: `linear-gradient(to bottom, ${headerBackground} 0%, ${headerBackground} 100%)`,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
      },
    },
    MuiTablePagination: {
      defaultProps: {
        backIconButtonProps: {
          size: 'small',
        },
        nextIconButtonProps: {
          size: 'small',
        },
      },
      styleOverrides: {
        root: {
          width: '100%',
        },
        toolbar: {
          height: 64,
        },
        actions: {
          marginRight: 8,
        },
        select: {
          paddingLeft: 8,
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          right: 4,
          width: 16,
          height: 16,
          top: 'calc(50% - 8px)',
        },
      },
    },
  };
}
